module.exports = __webpack_public_path__ + "static/front/img/sidebar-banner.c782979b.png";